import { createContext } from "react";

const LongFormContext = createContext(null as any);

export default LongFormContext;
